// ============================================================================
//  Koszyk — zachowania strony koszyka (redesign).
//
//  Zastępuje cart-page'ową część legacy `js/cart.js` (przełączanie planu
//  subskrypcji, modal „jak działa subskrypcja") oraz `js/quantity.js` (stepper).
//  Bez jQuery.
//
//  WSZYSTKO NA DELEGACJI ZDARZEŃ NA `document`. Powód: po każdej zmianie
//  WooCommerce podmienia `form.woocommerce-cart-form` i `div.cart_totals`
//  w całości (`update_wc_div`), więc listenery przypięte do konkretnych węzłów
//  by przepadły. Legacy JS radził sobie z tym re-initem na `updated_wc_div`
//  (i podwójnym bindowaniem) — delegacja usuwa problem u źródła.
//
//  Kontrakt z WooCommerce: zmiany zapisuje ukryty `button[name="update_cart"]`.
//  WooCommerce ma na niego własny handler, który robi AJAX-owy update koszyka —
//  klikamy go zamiast składać własne żądanie.
// ============================================================================

(() => {
	// Skrypt ładowany tylko na koszyku, ale guard chroni przed przypadkowym
	// wpięciem gdzie indziej. Plik leci z `defer`, więc DOM już jest.
	if (!document.querySelector('.c-cart')) {
		return;
	}

	const UPDATE_DELAY = 350; // scala serie klików +/- w jedno żądanie

	let updateTimer = null;

	/** Zleca WooCommerce przeliczenie koszyka (AJAX). */
	function requestCartUpdate(immediate) {
		const button = document.querySelector('[name="update_cart"]');

		if (!button) {
			return;
		}

		window.clearTimeout(updateTimer);

		const run = () => {
			button.removeAttribute('disabled');
			button.click();
		};

		if (immediate) {
			run();
			return;
		}

		updateTimer = window.setTimeout(run, UPDATE_DELAY);
	}

	// ── Plan zakupu (jednorazowo / subskrypcja) ──────────────────────────────
	// Radio pochodzi z All Products for Subscriptions; zmiana = od razu przelicz.
	document.addEventListener('change', (event) => {
		const target = event.target;

		if (!(target instanceof HTMLInputElement) || target.type !== 'radio') {
			return;
		}

		if (!target.closest('.c-cart-item__options')) {
			return;
		}

		requestCartUpdate(true);
	});

	// ── Stepper ilości ───────────────────────────────────────────────────────
	document.addEventListener('click', (event) => {
		const button = event.target.closest('[data-qty-step]');

		if (!button) {
			return;
		}

		const stepper = button.closest('.c-cart-item__stepper');
		const input = stepper && stepper.querySelector('input[type="number"]');

		if (!input) {
			return;
		}

		event.preventDefault();

		const step = parseInt(button.dataset.qtyStep, 10) || 0;
		const min = input.min === '' ? 0 : parseInt(input.min, 10);
		const max = input.max === '' ? Infinity : parseInt(input.max, 10);
		const current = parseInt(input.value, 10) || 0;
		const next = Math.min(Math.max(current + step, min), max);

		if (next === current) {
			return;
		}

		input.value = String(next);
		input.dispatchEvent(new Event('change', { bubbles: true }));
	});

	// Ręczna edycja pola ilości (klawiatura) — ta sama ścieżka co +/-.
	document.addEventListener('change', (event) => {
		const input = event.target;

		if (!(input instanceof HTMLInputElement) || input.type !== 'number') {
			return;
		}

		if (!input.closest('.c-cart-item__stepper')) {
			return;
		}

		const min = input.min === '' ? 0 : parseInt(input.min, 10);
		const value = parseInt(input.value, 10);

		if (Number.isNaN(value) || value < min) {
			input.value = String(min);
		}

		requestCartUpdate(false);
	});

	// ── Modal „jak działa subskrypcja" ───────────────────────────────────────
	const getModal = () => document.getElementById('c-cart-subinfo');

	function openModal(trigger) {
		const modal = getModal();

		if (!modal) {
			return;
		}

		modal.classList.add('is-open');
		modal.removeAttribute('hidden');

		if (trigger) {
			trigger.setAttribute('aria-expanded', 'true');
		}

		const close = modal.querySelector('[data-subinfo-close]');

		if (close) {
			close.focus();
		}
	}

	function closeModal() {
		const modal = getModal();

		if (!modal || !modal.classList.contains('is-open')) {
			return;
		}

		modal.classList.remove('is-open');
		modal.setAttribute('hidden', '');

		const trigger = document.querySelector('[data-subinfo-open]');

		if (trigger) {
			trigger.setAttribute('aria-expanded', 'false');
			trigger.focus();
		}
	}

	document.addEventListener('click', (event) => {
		const opener = event.target.closest('[data-subinfo-open]');

		if (opener) {
			event.preventDefault();
			openModal(opener);
			return;
		}

		if (event.target.closest('[data-subinfo-close]')) {
			event.preventDefault();
			closeModal();
			return;
		}

		// Klik w tło (poza panelem) zamyka.
		const modal = event.target.closest('.c-cart-subinfo__layer');

		if (modal && !event.target.closest('.c-cart-subinfo__panel')) {
			closeModal();
		}
	});

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape') {
			closeModal();
		}
	});
})();
